<template>
  <v-navigation-drawer
    v-model="$store.state.ui.leftmenu"
    :mini-variant="
      $vuetify.breakpoint.mdAndUp && $store.state.ui.leftmenu
    "
    :mini-variant-width="60"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :absolute="$vuetify.breakpoint.smAndDown"
    :temporary="$vuetify.breakpoint.smAndDown"
    hide-overlay
    class="background-nav vertical-stretch seconday--font left-menu"
    width="256"
    style="overflow:hidden"
    :class="$store.state.ui.leftmenu ? 'min-drawer' : 'open-navigation'"
    :key="visible_menus.length"
  >
    <v-divider />
    <v-list
      dense
      class="float-left pa-0"
      :width="$store.state.ui.leftmenu ? '' : '100%'"
    >
      <div
        v-for="(item, index) in menu_items"
        :key="index"
      >
        <v-tooltip
          right
          :disabled="!$store.state.ui.leftmenu"
        >
          <template v-if="item.subitems" v-slot:activator="{ on }">
            <div v-on="on">
              <v-list-group
                v-if="item.show"
                :id="item.id"
                :key="item.title"
                v-model="item.active"
                :class="highlight_tab[index] ? 'highlight' : ''"
                class="white--text"
                no-action
                color
                @click="openSubItems($event)"
              >
                <template v-slot:activator>
                  <v-list-item-icon class="mr-3 my-4">
                    <v-icon
                      id="menuIcon"
                      class="white--text"
                    >
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2 text-uppercase font-weight-bold">
                      <span class="secondary--font"> {{item.title}} </span>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template
                  v-for="subItem in item.subitems"
                >
                  <v-list-item
                    :key="subItem.title"
                    :to="subItem.path"
                    v-if="subItem.show"
                    exact
                    class="pl-8"
                    :class="subItem.path === $route.path ? 'v-list-item--active' : ''"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        class="white--text pl-2 secondary--font"
                        v-text="subItem.title"
                     />
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>
            </div>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>

        <v-tooltip
          right
          :disabled="!$store.state.ui.leftmenu"
        >
          <template v-if="!item.subitems" v-slot:activator="{ on }">
            <div v-on="on">
              <v-list-item
                :key="item.title"
                v-if="item.show"
                v-model="item.active"
                :class="
                  (highlight_tab[index] ? 'highlight' : '') +
                    ' ' +
                    (item.path === $route.path ? 'v-list-item--active' : '')
                "
                link
                :to="item.path"
                exact
                :href="item.href"
              >
                <v-list-item-icon class="mr-3 my-4"
                  v-if="item.newBadge && $store.state.ui.leftmenu">
                  <v-badge
                    overlap
                    color="green"
                    class="small-badge d-none d-md-flex"
                  >
                    <template v-slot:badge>
                      <span
                        class="d-none d-md-flex"
                      />
                    </template>
                    <v-icon
                      align="center"
                    >
                      {{ item.icon }}
                    </v-icon>
                  </v-badge>
                  <v-icon
                    class="d-md-none"
                    align="center"
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-icon v-else class="mr-3 my-4">
                  <v-icon
                    id="menuIcon"
                    class="white--text"
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">
                   <span class="secondary--font"> {{ item.title }} </span>
                    <v-chip
                      v-if="item.newBadge"
                      class="ml-6 green white--text text-capitalize px-1 greenchip"
                      label
                      small
                    >
                      New
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </div>
    </v-list>
    <template v-slot:append>
      <v-list
        dense
        class="float-left pa-0"
        :width="$store.state.ui.leftmenu ? '' : '100%'"
      >
        <v-tooltip
          right
          :disabled="!$store.state.ui.leftmenu"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-list-item-group color="primary">
                <v-list-item
                  link
                  target="_blank"
                  href="https://galaxy.maropost.com/categories/marketing-cloud"
                >
                  <v-list-item-icon class="pr-0 mr-3 my-4">
                    <v-icon
                      class="white--text"
                      v-text="'contact_support'"
                  />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2 font-weight-bold">
                      <span class="secondary--font"> Help Center</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </div>
          </template>
          <span>Help Center</span>
        </v-tooltip>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>

import constants from '@/constants'
import { getSplitKey } from '@/splitClient';
  export default {
    name: 'LeftMenuBar',
    props: {
      accountId: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        drawer_val: null,
        hover: false,
        highlight_tab: [],
        subitemsList: null,
        items: [
          {
            title: 'Dashboard',
            icon: 'mdi-home',
            path: 'dashboard',
            id: 'dashboard',
          },
          {
            title: 'Contacts',
            icon: 'mdi-contacts',
            path: 'contacts',
            id: 'contacts',
            condition : ()=>{
              return  getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount)
            }
          },
          {
            title: 'Analytics',
            icon: 'assessment',
            id: 'analyticId',
            privilege_group: ['reports','download_reports'],
            subitems: [
              {
                title: 'eRFM Report',
                path: 'erfm_report',
                condition : ()=>{
                  const setting = this.$store.getters['auth/packageFeatures']
                  if(setting.account_setting){
                    if(setting.account_setting.erfm_enabled)
                      return setting.account_setting.erfm_enabled
                    return false
                  }
                  return false
                }
              },
              {
                title: 'Campaign Reports',
                path: 'reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Recurring Campaign Reports',
                path: 'reports/recurring_campaign_report',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'A/B Campaign Reports',
                path: 'ab_reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Test Campaign Reports',
                path: 'reports/test_reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Website Reports',
                path: 'website_reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Journey Reports',
                path: 'reports/journeys',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Custom Reports',
                path: 'analytics/custom_reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Transactional Reports',
                path: 'transactional_campaigns/reports',
                privilege_group: ['reports','download_reports']
              },
              {
                title: 'Log Inspector',
                path: 'get_logs',
                privilege_group: ['reports','download_reports']
              },
            ],
          },
          {
            title: 'Campaigns',
            icon: 'send',
            id: 'campaignsId',
            privilege_group: ['campaigns','mobile'],
            subitems: [
              {
                title: 'Email Campaigns',
                path: 'campaigns',
                privilege_group: 'campaigns'
              },
              {
                title: 'Batch Campaigns',
                path: 'batch_campaigns/new',
                allowed_account: [25],
                privilege_group: 'campaigns'
              },
              {
                title: 'SMS Campaigns',
                path: 'sms_campaigns',
                privilege_group: 'mobile',
                condition : ()=>{
                  return this.$store.getters['auth/checkRole']('mobile')
                }
              },
              {
                title: 'Push Campaigns',
                path: 'push_applications',
                privilege_group: 'mobile'
              },
              {
                title: 'Transactional Campaigns',
                path: 'transactional_campaigns',
                privilege_group: 'campaigns'
              },
              {
                title: 'Transactional SMS Campaigns',
                path: 'transactional_sms_campaigns',
                privilege_group: 'mobile',
                condition : ()=>{ 
                  return this.$store.getters['auth/checkRole']('mobile')
                }
              },
              {
                title: 'Campaign Tags',
                path: 'ctags',
                privilege_group: 'campaigns'
              },
            ],
          },
          {
            title: 'Social',
            icon: 'campaign',
            id: 'socialId',
            subitems: [
              {
                title: 'Schedule Social Campaigns',
                path: 'social_schedules',
              },
              {
                title: 'Queued Social Campaigns',
                path: 'social_schedules/queue',
              },
              {
                title: 'Social Content',
                path: 'social_campaigns',
              },
              {
                title: 'Social Categories',
                path: 'social_content_categories',
              },
              {
                title: 'Connected Social Accounts',
                path: 'social_accounts',
              },
              {
                title: 'Lead Ads',
                path: 'social_leads',
              },
            ],
 
          },
          {
            title: 'Acquisition',
            icon: 'business_center',
            id: 'acquisitionId',
            subitems: [
              {
                title: 'Acquisition Forms',
                path: 'acquisition/forms',
                privilege_group: 'forms',
              },
              {
                title: 'Landing Pages',
                path: 'landing_pages',
              },
              {
                title: 'Signup Forms (Old)',
                path: 'forms',
                privilege_group: 'forms',
              },
              {
                title: 'Surveys',
                path: 'surveys',
                privilege_group: 'surveys',
              },
            ],
          },
          {
            title: 'Automation',
            icon: 'device_hub',
            id: 'automationId',
            subitems: [
              { title: 'Journeys', path: 'journeys' },
              {
                title: 'Data Journeys',
                path: 'data_journeys',
              },
            ],
          },
          {
            title: 'Audience',
            icon: 'account_circle',
            id: 'audienceId',
            subitems: [
              { 
                title: getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? 'Contact Lists' : 'Email Contact Lists', 
                path: 'lists',
                privilege_group: 'contacts' 
              },
              { 
                title: 'Segments', 
                path: 'segments', 
                privilege_group: 'contacts' 
              },
              { 
                title: 'Fields', 
                path: 'custom_fields',
                privilege_group: 'contacts' 
              },{ 
                title: 'Contact Tags', 
                path: 'tags',
                privilege_group: 'contacts' 
              },{
                title: 'Relational Tables',
                path: 'relational_tables',
                privilege_group: 'contacts' 
              },
              {
                title: 'SQL Queries',
                path: 'relational_queries',
                privilege_group: 'contacts' 
              },
              {
                title: 'Preference Management',
                path: 'preference_pages',
                privilege_group: 'contacts' 
              },
              { 
                title: 'Brand Management', 
                path: 'brands', 
                privilege_group: 'contacts'  
              },
              { 
                title: 'Secure Lists', 
                path: 'secure_lists', 
                privilege_group: 'contacts'  
              },
              {
                title: 'Cleansing Rules',
                path: 'cleansing_rules',
              },
              {
                title: 'Web Tracking',
                path: 'websites',
                privilege_group: 'forms',
              },
              {
                title: 'SMS Contact Lists',
                path: 'sms_lists',
                privilege_group: 'mobile',
                condition : ()=>{
                  return !getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount)
                }
              },
            ],
          },
          {
            title: 'Content',
            icon: 'photo_library',
            id: 'libraryId',
            subitems: [
              {
                title: 'Dynamic Content',
                path: 'dynamic_contents',
                privilege_group: 'contents'
              },
              {
                title: 'Email Content',
                path: 'contents',
                privilege_group: 'contents'
              },
              {
                title: 'Image Library',
                path: 'folders',
                privilege_group: 'contents'
              },
              {
                title: 'Footer Management',
                path: 'footers',
                privilege_group: 'contents'
              },
              {
                title: 'Optimize On Open',
                path: 'image_groups',
                privilege_group: 'contents'
              },
              {
                title: 'Content Feeds',
                path: 'content_feeds',
                privilege_group: 'contents'
              },
              {
                title: 'Product Recommendations',
                path: 'product_recommendations',
                privilege_group: 'contents',
              },
              {
                title: 'Coupon Banks',
                path: 'coupon_banks',
                privilege_group: 'contents'
              },
              {
                title: 'Countdown Timer',
                path: 'live_content_images',
                privilege_group: 'contents'
              },
              {
                title: 'Mobile Keywords',
                path: 'mobile_keywords',
                privilege_group: 'mobile',
                condition : ()=>{
                  return this.$store.getters['auth/checkRole']('mobile')
                }
              },
            ],
          },
          {
            title: 'Integrations',
            icon: 'mdi-puzzle',
            id: 'integrationsId',
            path: 'integrations',
          },
          {
            title: 'Archives',
            icon: 'archive',
            path: 'archive'
          },
        ],
      }
    },
    computed: {
      visible_menus(){
        let current = this.$store.getters['auth/account.current'];
        return (current && "visible_menus" in current) ? current.visible_menus : [];
      },
      menu_items () {
        let visible_menu = this.visible_menus
        let account = this.$store.state.auth.account;
        const check_permissions = (account.current && account.current.owner_id) ? account.current.owner_id !== account.id : true
        let accountId = this.$store.getters['auth/account'].id
        let a = this.items.map((item) => {
          if (!item.relative && item.path && accountId) {
            item.path = item.path.replace(/\/accounts\/\d*\//g, '')
            item.path = '/accounts/' + accountId + '/' + item.path
          }
          
          item.show = item.privilege_group == undefined || (visible_menu.length && this.checkMenuPermission(item.privilege_group) && (!check_permissions || this.$store.getters['auth/checkRole'](item.privilege_group)))
          

          if(item.allowed_account && !item.allowed_account.includes(accountId)){
            item.show = false
          }
          if(typeof (item.condition) == "function"){
              item.show = item.condition();
            }
          if(item.show){
            if (item.subitems) {
              item.subitems = item.subitems.map((subitem) => {
                if (!item.relative && subitem.path && accountId) {
                  subitem.path = subitem.path.replace(/\/accounts\/\d*\//g, '')
                  subitem.path = '/accounts/' + accountId + '/' + subitem.path
                }
                subitem.show = subitem.privilege_group == undefined || (visible_menu.length && this.checkMenuPermission(subitem.privilege_group) && (!check_permissions || this.$store.getters['auth/checkRole'](subitem.privilege_group)))
                if(subitem.allowed_account && !subitem.allowed_account.includes(accountId)){
                  subitem.show = false
                }
                if(typeof (subitem.condition) == "function"){
                  subitem.show = subitem.condition();
                }
                return subitem
              })
            }
          }
          if(item.subitems){
            let subMenuItems = item.subitems.filter(x=>x.show)
            if(subMenuItems.length ==0)
              item.show = false;
          }
          return item
        })
        return a
      },
    },
    watch: {
      $route (to, from) {
        this.checkIsActive(to)
      },
    },
    mounted () {
      this.checkIsActive(this.$route)
      this.$root.$on('collapseSidebarNav', () => this.collapseItems())
      
    },
    methods: {
      checkMenuPermission(item){
        if (!item) return true;
        if(typeof item === 'string')
          return this.visible_menus.includes(item)

        return (item.filter(value => this.visible_menus.includes(value))).length>0
      },
      openSubItems(e){
        const iconID = e.target.textContent;
        if(this.$store.state.ui.leftmenu === true){
          const activeTab = this.items.filter(item => {return (item.icon === iconID)});
          let activeTabId = '';
          if(activeTab && activeTab.length){
            activeTabId = activeTab[0].id;
            }
          this.$store.commit('ui/leftmenu', false)
          if(activeTabId && activeTabId.length){
            setTimeout(() => {
            this.items.forEach(item=>{
                if(item.id === activeTabId){
                  item.active = true;
                  }
              })
          }, 0)
          }
        }
      },
      
      checkIsActive (to) {
        this.items.forEach((ele, index) => {
          if (ele.path) {
            if (ele.path === to.path || (ele.id === 'dashboard' && (String(ele.path).split('/')[2] !== String(to.path).split('/')[2]))) {
              this.highlight_tab = []
              this.highlight_tab[index] = true
              
            }
          } else {
            ele.subitems.forEach(subele => {
              if (subele.path === to.path) {
                this.highlight_tab = []
                this.highlight_tab[index] = true
                
              }
            })
          }
        })
      },
      highlight (index) {
        this.highlight_tab = []
        this.highlight_tab[index] = true
        
      },
      collapseItems () {
        this.items.forEach(item => {
          if (item.active) {
            _.delay(function () { item.active = false }, 300)
            return false
          }
        })
      },
    },
  }
</script>

<style lang="scss">
  $green-color: #41ce65 !important;
  $left-menu-background: #1e2533 !important;
  $primary-blue-color: #03b6fc;
  $menu-active-color: #464c56;
  $menu-active-icon: #fff !important;

  @mixin box-shadow {
    box-shadow: 5px 0px 0px $primary-blue-color inset;
    background-color: $menu-active-color;
    color: $menu-active-icon;
  }
  @mixin hover-only {
    @media not all and (pointer: coarse) {
      &:hover {
        @content;
      }
    }
  }

  #mySidenav {
    .highlight {
      @include box-shadow;
      .v-list-item__content,
      .v-icon {
        color: $menu-active-icon;
      }
    }
    .open-navigation,
    .v-navigation-drawer--is-mobile {
      .v-list-group {
        &--active {
          box-shadow: 0px 0px 0px #03b6fc inset !important;
          background: #2e3543;
        }
        &__header {
          @include hover-only() {
            background: #2e3543;
          }
        }
        a.v-list-item {
          min-height: 40px !important;
          &:hover {
            background-color: #4f555b;
          }
          &--active {
            box-shadow: 5px 0px 0px $primary-blue-color inset;
            background-color: #4f555b;
            .v-list-item__content .v-list-item__title {
              font-weight: bold;
            }
          }
        }
      }
    }

    .v-list-item--link:before {
      background-color: transparent;
    }

    .background-nav {
      background-color: $left-menu-background;
    }
    .background-nav .v-list {
      background-color: inherit !important;
    }
    .v-list-item,
    .v-icon {
      color: #aaacb1 !important;
    }
    .v-list-item {
      @include hover-only() {
        background: #2e3543;
      }
      min-height: 59px !important;
    }
    .green {
      background-color: $green-color;
    }
    .greenchip {
      height: 18px;
      font-size: 11px;
    }
    .v-badge--overlap .v-badge__badge {
      top: -12px !important;
      left: 15px !important;
      bottom: auto !important;
    }
    .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transition: rotate(-90deg);
      -webkit-transform: rotate(-90deg);
    }
    .v-list-group--active
      > .v-list-group__header
      > .v-list-group__header__append-icon
      .v-icon {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    .v-list-item__title,
    .v-list-item__subtitle {
      white-space: normal;
    }
    .v-navigation-drawer--is-mobile .v-list {
      width: 100% !important;
    }
  }
</style>
<style scoped>
.v-tooltip__content{
  margin-left: -27px;
}
</style>
